/**
 * featureFlagStore.ts
 *
 * Decides which beta features the signed-in user sees. Grants come with the
 * login and refresh responses (`LoginResponse.features`), set by an admin on
 * /admin/feature-users; admins see every feature.
 */
import { defineStore } from 'pinia'
import { computed } from 'vue'
import { FEATURE_BET_LIMIT, canSeeBetLimit as canSeeBetLimitFor } from '@/constants/featureFlags'
import { useAuthStore } from '@/stores/authStore'

export const useFeatureFlagStore = defineStore('featureFlag', () => {
  const authStore = useAuthStore()

  // A session stored before `features` existed has none.
  const features = computed<string[]>(() => authStore.userData?.features ?? [])

  /** True when the Dư chuẩn menu entry, routes and buttons are shown. */
  const canSeeBetLimit = computed(() =>
    canSeeBetLimitFor(authStore.isAdmin, features.value.includes(FEATURE_BET_LIMIT)),
  )

  return { canSeeBetLimit }
})
